const osOptions = ['Android', 'iOS', 'Other'];
const getDevice = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua) && navigator.maxTouchPoints > 1) {
        return osOptions[0];
    } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return osOptions[1];
    }
    return osOptions[2];
};

const device = getDevice();
const googlePlayURL = 'https://play.google.com/store/apps/details?id=com.calzedoniagroup.tezenis';
const appStoreURL = 'https://apps.apple.com/it/app/tezenis/id1532750548';

if (device === osOptions[0]) location.href = googlePlayURL;
if (device === osOptions[1]) location.href = appStoreURL;
